module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60019f33!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth.vue
// module id = 1136
// module chunks = 23